import React from 'react';
import { Chart, Tooltip, Interval, Interaction } from 'bizcharts';
import _ from 'lodash';
import { Col, Row } from 'antd';
import Loading from '../../common/Loading';

const GraficosEstadosExpedientes = props => {
  const data = _.get(props, 'data', []);

  if (props.loading) {
    return <Loading />;
  }

  if (data.length < 1) {
    return (
      <Row>
        <Col span={12} offset={6}>
          <h2 style={{ textAlign: 'center' }}>
            NO HAY DATOS PARA ESTE ORGANISMO EN ESTE AÑO
          </h2>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col span={8} offset={8}>
          <h2 style={{ textAlign: 'center' }}>
            Estados de Expedientes Por Mes
          </h2>
        </Col>
      </Row>
      <Chart
        height={400}
        padding="auto"
        data={data}
        autoFit
        filter={[['cantidad', val => val != null]]}
      >
        <Interval
          adjust={[
            {
              type: 'dodge',
              marginRatio: 0,
            },
          ]}
          color={[
            'estado',
            xVal => {
              if (xVal === 'EN TRAMITE') {
                return '#108ee9';
              }
              if (xVal === 'FINALIZADO') {
                return '#f50';
              }
              return '#36f2f5';
            },
          ]}
          position="mes*cantidad"
        />
        <Tooltip shared />
        <Interaction type="active-region" />
      </Chart>
    </>
  );
};

export default GraficosEstadosExpedientes;
